import type { ChangelogStore } from './interfaces'

export const actions = {
  setLoading (this: ChangelogStore, payload: ChangelogStore['loading']): void {
    this.loading = payload
  },
  setActions (this: ChangelogStore, payload: ChangelogStore['actions']): void {
    this.actions = payload
  },
  setMeta (this: ChangelogStore, payload: ChangelogStore['meta']): void {
    this.meta = payload
  },
  setFilterSearch (this: ChangelogStore, payload: ChangelogStore['filterSearch']): void {
    this.filterSearch = payload
  },
  setFilterFrom (this: ChangelogStore, payload: ChangelogStore['filterFrom']): void {
    this.filterFrom = payload
  },
  setFilterTo (this: ChangelogStore, payload: ChangelogStore['filterTo']): void {
    this.filterTo = payload
  },
  setPerPage (this: ChangelogStore, payload: ChangelogStore['perPage']): void {
    this.perPage = payload
  },
  setCursor (this: ChangelogStore, payload: ChangelogStore['cursor']): void {
    this.cursor = payload
  },
  setExpandedActionId (this: ChangelogStore, payload: ChangelogStore['expandedActionId']): void {
    this.expandedActionId = payload
  },
  setItems (this: ChangelogStore, payload: ChangelogStore['items']): void {
    this.items = payload
  },
  setItemsLoading (this: ChangelogStore, payload: ChangelogStore['itemsLoading']): void {
    this.itemsLoading = payload
  },
  resetFilters (this: ChangelogStore): void {
    this.filterSearch = null
    this.filterFrom = null
    this.filterTo = null
    this.cursor = null
  },
}
